/* HAUSMANN SLEEP — small progressive enhancements. No tracking code here:
   the Meta Pixel runs through Shopify's Facebook & Instagram app. */
(function () {
  'use strict';

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD' }).format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  /* Product: variant picker */
  document.querySelectorAll('[data-product-section]').forEach(function (section) {
    var json = section.querySelector('[data-variants]');
    var mainImage = section.querySelector('[data-main-image]');

    section.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImage) return;
        mainImage.removeAttribute('srcset');
        mainImage.src = thumb.getAttribute('data-src');
        mainImage.alt = thumb.getAttribute('data-alt') || '';
        section.querySelectorAll('[data-thumb]').forEach(function (t) { t.removeAttribute('aria-current'); });
        thumb.setAttribute('aria-current', 'true');
      });
    });

    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var inputs = section.querySelectorAll('[data-option-input]');

    function update() {
      var selected = [];
      section.querySelectorAll('.option-group').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });
      var variant = variants.find(function (v) {
        return v.options.every(function (o, i) { return o === selected[i]; });
      });
      var buttons = section.querySelectorAll('[data-add-button]');
      if (!variant) {
        buttons.forEach(function (b) { b.disabled = true; });
        return;
      }
      section.querySelectorAll('[data-variant-id]').forEach(function (i) { i.value = variant.id; });
      buttons.forEach(function (b) { b.disabled = !variant.available; });
      var main = section.querySelector('form [data-add-button]');
      if (main) main.textContent = variant.available ? 'Add to bag' : 'Sold out';

      var price = section.querySelector('[data-price]');
      var compare = section.querySelector('[data-compare]');
      var badge = section.querySelector('[data-badge]');
      if (price) price.textContent = formatMoney(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compare) { compare.hidden = !onSale; if (onSale) compare.textContent = formatMoney(variant.compare_at_price); }
      if (badge) { badge.hidden = !onSale; if (onSale) badge.textContent = '−' + Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) + '%'; }

      if (variant.featured_image && mainImage) {
        mainImage.removeAttribute('srcset');
        mainImage.src = variant.featured_image.src;
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }
    inputs.forEach(function (input) { input.addEventListener('change', update); });
  });

  /* Cart: quantity steppers (auto-update) */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var timer;
    function submitSoon() {
      clearTimeout(timer);
      timer = setTimeout(function () { cartForm.submit(); }, 400);
    }
    cartForm.querySelectorAll('[data-qty-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentElement.querySelector('[data-qty-input]');
        var next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
        input.value = next;
        submitSoon();
      });
    });
    cartForm.querySelectorAll('[data-qty-input]').forEach(function (input) {
      input.addEventListener('change', submitSoon);
    });
  }


  /* Pair pop-up: after adding ONE pillow, offer a second one before going to the bag.
     Uses Shopify's cart AJAX API (tracked natively as AddToCart by the Facebook & Instagram app). */
  (function () {
    var HS = window.HS || {};
    var modal = document.getElementById('PairModal');
    if (!HS.pairPopup || !modal) { window.HSPair = null; return; }
    if (document.body.classList.contains('template-cart')) return;
    var lastVariant = null;
    var lastFocus = null;

    function goToCart() { if (window.HSDrawer) { closeModal(); window.HSDrawer.open(true); } else window.location.href = HS.cartUrl; }

    function updateCount(count) {
      var link = document.querySelector('.cart-link');
      if (!link) return;
      var badge = link.querySelector('.cart-count');
      if (!badge) { badge = document.createElement('span'); badge.className = 'cart-count'; badge.setAttribute('aria-hidden', 'true'); link.appendChild(badge); }
      badge.textContent = count;
    }

    function openModal(item) {
      lastVariant = item.variant_id;
      var img = modal.querySelector('[data-pair-image]');
      if (img) { img.src = item.image || item.featured_image && item.featured_image.url || ''; img.alt = item.product_title || ''; }
      var title = modal.querySelector('[data-pair-title]');
      if (title) title.textContent = item.product_title + (item.variant_title && item.variant_title !== 'Default Title' ? ' — ' + item.variant_title : '');
      lastFocus = document.activeElement;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var accept = modal.querySelector('[data-pair-accept]');
      if (accept) accept.focus();
    }

    function closeModal() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    modal.querySelectorAll('[data-pair-close]').forEach(function (el) { el.addEventListener('click', closeModal); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) closeModal(); });

    var decline = modal.querySelector('[data-pair-decline]');
    if (decline) decline.addEventListener('click', function (e) { if (!window.HSDrawer) return; e.preventDefault(); goToCart(); });

    var accept = modal.querySelector('[data-pair-accept]');
    if (accept) accept.addEventListener('click', function () {
      if (!lastVariant) return goToCart();
      accept.disabled = true;
      fetch(HS.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: lastVariant, quantity: 1 }] })
      }).then(function () { accept.disabled = false; goToCart(); }, function () { accept.disabled = false; goToCart(); });
    });

    window.HSPair = { open: openModal, updateCount: updateCount, goToCart: goToCart };

    document.querySelectorAll('form[action$="/cart/add"]:not([data-bundle-form])').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var qtyInput = form.querySelector('input[name="quantity"]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (qty !== 1 || !window.fetch || !window.FormData) return; // pairs go straight to the bag
        e.preventDefault();
        var button = form.querySelector('[type="submit"]');
        if (button) button.disabled = true;
        fetch(HS.cartAddUrl + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (item) {
            return fetch(HS.cartJsUrl, { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (cart) {
                if (button) button.disabled = false;
                updateCount(cart.item_count);
                if (cart.item_count === 1) openModal(item); else goToCart();
              });
          })
          .catch(function () { if (button) button.disabled = false; form.submit(); });
      });
    });
  })();


  /* ===== v1.0.5 product page ===== */
  function addItems(items) {
    var HS = window.HS || {};
    return fetch((HS.cartAddUrl || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); });
  }
  function getCart() {
    var HS = window.HS || {};
    return fetch(HS.cartJsUrl || '/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* Gallery: swipe + dots + arrows + thumbs */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var track = g.querySelector('[data-gallery-track]');
    if (!track) return;
    var slides = track.querySelectorAll('[data-slide]');
    var dots = g.querySelectorAll('[data-gallery-dot]');
    var thumbs = g.querySelectorAll('[data-gallery-thumb]');
    function go(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
    function current() { return Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); }
    function mark() {
      var i = current();
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    }
    var t; track.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(mark, 60); }, { passive: true });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(+d.getAttribute('data-gallery-dot')); }); });
    thumbs.forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-gallery-thumb')); }); });
    var prev = g.querySelector('[data-gallery-prev]'), next = g.querySelector('[data-gallery-next]');
    if (prev) prev.addEventListener('click', function () { go(current() - 1); });
    if (next) next.addEventListener('click', function () { go(current() + 1); });
  });

  /* Choose your set (1 or 2 pillows, colour per pillow) */
  document.querySelectorAll('[data-bundle-form]').forEach(function (form) {
    var submit = form.querySelector('[data-bundle-submit]');
    function label() {
      if (!submit || submit.disabled) return;
      var c = form.querySelector('input[name="hs_set"]:checked');
      var price = c && c.getAttribute('data-set-price');
      submit.textContent = (submit.getAttribute('data-label') || 'Add to bag') + (price ? ' — ' + price : '');
    }
    form.querySelectorAll('input[name="hs_set"]').forEach(function (r) { r.addEventListener('change', label); });
    label();
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      var checked = form.querySelector('input[name="hs_set"]:checked');
      var set = checked ? checked.value : '1';
      var selects = form.querySelectorAll('select[data-set="' + set + '"]');
      var counts = {}, order = [];
      selects.forEach(function (sel) { var id = sel.value; if (!counts[id]) { counts[id] = 0; order.push(id); } counts[id]++; });
      var items = order.map(function (id) { return { id: +id, quantity: counts[id] }; });
      if (!items.length) return;
      if (submit) submit.disabled = true;
      addItems(items).then(function (res) {
        return getCart().then(function (cart) {
          if (submit) submit.disabled = false;
          var pair = window.HSPair;
          if (pair) pair.updateCount(cart.item_count);
          var first = res && res.items ? res.items[0] : null;
          if (set === '1' && cart.item_count === 1 && pair && first) pair.open(first);
          else if (window.HSDrawer) window.HSDrawer.open(true);
          else window.location.href = (window.HS && window.HS.cartUrl) || '/cart';
        });
      }).catch(function () {
        if (submit) submit.disabled = false;
        form.submit();
      });
    });
  });

  /* Delivery timeline dates (business days) */
  function addBusinessDays(date, n) {
    var d = new Date(date.getTime());
    while (n > 0) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) n--; }
    return d;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  document.querySelectorAll('[data-delivery]').forEach(function (el) {
    var today = new Date();
    var pMin = +el.getAttribute('data-process-min'), pMax = +el.getAttribute('data-process-max');
    var tMin = +el.getAttribute('data-transit-min'), tMax = +el.getAttribute('data-transit-max');
    var shipA = addBusinessDays(today, pMin), shipB = addBusinessDays(today, pMax);
    var arrA = addBusinessDays(shipA, tMin), arrB = addBusinessDays(shipB, tMax);
    var a = el.querySelector('[data-delivery-today]'), b = el.querySelector('[data-delivery-ship]'), c = el.querySelector('[data-delivery-arrive]');
    if (a) a.textContent = fmt(today);
    if (b) b.textContent = pMin === pMax ? fmt(shipA) : fmt(shipA) + ' – ' + fmt(shipB);
    if (c) c.textContent = fmt(arrA) + ' – ' + fmt(arrB);
  });

  /* Rotating quotes */
  document.querySelectorAll('[data-quotes]').forEach(function (box) {
    var q = box.querySelectorAll('[data-quote]');
    if (q.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var i = 0;
    setInterval(function () { q[i].hidden = true; i = (i + 1) % q.length; q[i].hidden = false; }, 5000);
  });

  /* Sticky add-to-bag bar */
  (function () {
    var bar = document.querySelector('[data-sticky-buy]');
    var main = document.querySelector('[data-bundle-submit], [data-add-button]');
    if (!bar || !main || !('IntersectionObserver' in window)) return;
    bar.hidden = false;
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var below = e.boundingClientRect.top < 0; // button scrolled above the viewport
      bar.classList.toggle('is-visible', !e.isIntersecting && below);
    });
    io.observe(main);
    var btn = bar.querySelector('[data-sticky-submit]');
    if (btn) btn.addEventListener('click', function () {
      var form = main.closest('form');
      if (form && form.requestSubmit) form.requestSubmit(); else if (form) form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
  })();

  /* "Choose my set" buttons scroll back to the buy box */
  document.querySelectorAll('[data-scroll-to-buy]').forEach(function (a) {
    if (a.getAttribute('href') && a.getAttribute('href') !== '#') return;
    a.addEventListener('click', function (e) {
      var target = document.querySelector('.bundle, [data-add-button]');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });


  /* Videos: play muted only while visible (saves data, keeps the page fast) */
  (function () {
    var vids = document.querySelectorAll('.reel video, .gallery__slide--video video');
    if (!vids.length) return;
    vids.forEach(function (v) { v.muted = true; v.setAttribute('muted', ''); v.playsInline = true; });
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if ('IntersectionObserver' in window && !reduce) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var v = e.target;
          if (e.isIntersecting && e.intersectionRatio > 0.5) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          else v.pause();
        });
      }, { threshold: [0, 0.5, 1] });
      vids.forEach(function (v) { io.observe(v); });
    }
    document.querySelectorAll('[data-reel-sound]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var v = btn.parentElement.querySelector('video');
        if (!v) return;
        document.querySelectorAll('.reel video').forEach(function (o) { if (o !== v) { o.muted = true; var b = o.parentElement.querySelector('[data-reel-sound]'); if (b) { b.classList.remove('is-on'); b.setAttribute('aria-label', 'Turn sound on'); } } });
        v.muted = !v.muted;
        if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        btn.classList.toggle('is-on', !v.muted);
        btn.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
      });
    });
  })();

  /* Footer: "Cookie preferences" opens Shopify's native privacy banner */
  var cookieTries = 0;
  function initCookieLink() {
    var ready = window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function';
    if (!ready) {
      if (cookieTries++ < 20) setTimeout(initCookieLink, 500);
      return;
    }
    document.querySelectorAll('.js-cookie-preferences').forEach(function (btn) {
      btn.hidden = false;
      btn.addEventListener('click', function () { window.privacyBanner.showPreferences(); });
    });
  }
  if (document.readyState === 'complete') initCookieLink();
  else window.addEventListener('load', initCookieLink);

  /* ===== v1.0.8: pair code applied to the cart itself (real total in cart, works with express checkout) ===== */
  (function () {
    var HS = window.HS || {};
    var code = (HS.pairCode || '').trim();
    if (!code || !window.fetch || !document.body.classList.contains('template-cart')) return;
    var min = parseInt(HS.pairMin, 10) || 2;
    var key = 'hs-pair-sync';
    fetch(HS.cartJsUrl || '/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        var has = codes.some(function (c) { return c.toUpperCase() === code.toUpperCase(); });
        var want = cart.item_count >= min;
        if (want === has) { try { sessionStorage.removeItem(key); } catch (e) {} return; }
        var sig = cart.token + ':' + cart.item_count + ':' + want;
        try { if (sessionStorage.getItem(key) === sig) return; sessionStorage.setItem(key, sig); } catch (e) {}
        var others = codes.filter(function (c) { return c.toUpperCase() !== code.toUpperCase(); });
        var next = want ? others.concat([code]) : others;
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: next.join(',') })
        }).then(function () { window.location.reload(); });
      })
      .catch(function () {});
  })();


  /* ===== v1.0.8: slide-out cart drawer ===== */
  (function () {
    var el = document.getElementById('CartDrawer');
    if (!el || !window.fetch) return;
    var HS = window.HS || {};
    var code = (HS.pairCode || '').trim();
    var min = parseInt(HS.pairMin, 10) || 2;
    var save = parseInt(HS.pairSave, 10) || 0;
    var list = el.querySelector('[data-drawer-items]');
    var empty = el.querySelector('[data-drawer-empty]');
    var foot = el.querySelector('[data-drawer-foot]');
    var upsell = el.querySelector('[data-drawer-upsell]');
    var progress = el.querySelector('[data-drawer-progress]');
    var totalEl = el.querySelector('[data-drawer-total]');
    var lastTotal = null, lastFocus = null, closeTimer = null, wasUnlocked = null;

    function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML; }
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
    }
    function getCart() { return fetch((HS.cartJsUrl || '/cart.js'), { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
    function syncCode(cart) {
      if (!code) return cart;
      var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
      var up = code.toUpperCase();
      var has = codes.some(function (c) { return c.toUpperCase() === up; });
      var want = cart.item_count >= min;
      if (want === has) return cart;
      var others = codes.filter(function (c) { return c.toUpperCase() !== up; });
      return post('/cart/update.js', { discount: (want ? others.concat([code]) : others).join(',') }).catch(function () { return cart; });
    }
    function img(url, w) {
      if (!url) return '';
      try { var u = new URL(url, location.href); u.searchParams.set('width', w); return u.toString(); } catch (e) { return url; }
    }
    function animateTotal(to) {
      if (!totalEl) return;
      var from = lastTotal == null ? to : lastTotal;
      lastTotal = to;
      if (from === to || window.matchMedia('(prefers-reduced-motion: reduce)').matches) { totalEl.textContent = formatMoney(to); return; }
      var start = null, dur = 600;
      function step(ts) {
        if (!start) start = ts;
        var k = Math.min(1, (ts - start) / dur); k = 1 - Math.pow(1 - k, 3);
        totalEl.textContent = formatMoney(Math.round(from + (to - from) * k));
        if (k < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      totalEl.classList.remove('is-pop'); void totalEl.offsetWidth; totalEl.classList.add('is-pop');
    }
    function badge(count) {
      document.querySelectorAll('.cart-link').forEach(function (link) {
        var b = link.querySelector('.cart-count');
        if (!count) { if (b) b.remove(); return; }
        if (!b) { b = document.createElement('span'); b.className = 'cart-count'; b.setAttribute('aria-hidden', 'true'); link.appendChild(b); }
        b.textContent = count;
        b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump');
      });
      var c = el.querySelector('[data-drawer-count]'); if (c) c.textContent = count ? '(' + count + ')' : '';
    }
    function render(cart) {
      badge(cart.item_count);
      var isEmpty = !cart.item_count;
      empty.hidden = !isEmpty; foot.hidden = isEmpty; list.hidden = isEmpty;
      if (progress) progress.hidden = isEmpty;
      list.innerHTML = cart.items.map(function (it, i) {
        var colour = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : (it.product_title.split('—').pop() || '').trim();
        var name = it.product_title.split('—')[0].replace(/\s+$/, '');
        var orig = it.original_line_price, fin = it.final_line_price;
        return '<li class="drawer-item" style="--i:' + i + '" data-key="' + esc(it.key) + '">' +
          '<a href="' + esc(it.url) + '" class="drawer-item__img"><img src="' + esc(img(it.image, 240)) + '" alt="' + esc(it.product_title) + '" width="96" height="96" loading="lazy"></a>' +
          '<div class="drawer-item__info"><a href="' + esc(it.url) + '" class="drawer-item__name">' + esc(name) + '</a>' +
          '<p class="drawer-item__variant">' + esc(colour) + '</p>' +
          '<div class="drawer-item__row"><div class="qty qty--sm"><button type="button" data-q="-1" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-q="1" aria-label="Increase quantity">+</button></div>' +
          '<button type="button" class="drawer-item__remove" data-q="remove">Remove</button></div></div>' +
          '<div class="drawer-item__price">' + (orig !== fin ? '<s>' + formatMoney(orig) + '</s>' : '') + '<strong>' + formatMoney(fin) + '</strong></div></li>';
      }).join('');
      var saving = Math.max(0, (cart.items_subtotal_price || 0) - (cart.total_price || 0));
      var subRow = el.querySelector('[data-drawer-subtotal-row]'), savRow = el.querySelector('[data-drawer-saving-row]');
      if (subRow) { subRow.hidden = !saving; el.querySelector('[data-drawer-subtotal]').textContent = formatMoney(cart.items_subtotal_price); }
      if (savRow) { savRow.hidden = !saving; el.querySelector('[data-drawer-saving]').textContent = '−' + formatMoney(saving); }
      animateTotal(cart.total_price);
      var unlocked = cart.item_count >= min;
      if (progress) {
        var pct = Math.min(1, cart.item_count / min) * 100;
        progress.querySelector('[data-progress-fill]').style.width = pct + '%';
        progress.classList.toggle('is-done', unlocked);
        var tpl = unlocked ? (HS.progressDone || '') : (HS.progressTodo || '');
        progress.querySelector('[data-progress-text]').innerHTML = esc(tpl).replace('[amount]', '<strong>' + formatMoney(save) + '</strong>');
        if (unlocked && wasUnlocked === false) { progress.classList.remove('is-celebrate'); void progress.offsetWidth; progress.classList.add('is-celebrate'); }
      }
      wasUnlocked = unlocked;
      if (upsell) upsell.hidden = isEmpty || cart.item_count >= min;
      return cart;
    }
    function refresh() { return getCart().then(syncCode).then(render); }
    function open(doRefresh) {
      clearTimeout(closeTimer);
      lastFocus = document.activeElement;
      el.hidden = false;
      document.documentElement.classList.add('drawer-open');
      requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-open'); }); });
      el.classList.add('is-loading');
      var p = doRefresh === false ? Promise.resolve() : refresh();
      return p.then(function () { el.classList.remove('is-loading'); var c = el.querySelector('.cart-drawer__close'); if (c) c.focus({ preventScroll: true }); })
        .catch(function () { window.location.href = HS.cartUrl || '/cart'; });
    }
    function close() {
      el.classList.remove('is-open');
      document.documentElement.classList.remove('drawer-open');
      closeTimer = setTimeout(function () { el.hidden = true; }, 380);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    el.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.classList.contains('is-open')) close(); });
    list.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]'); if (!b) return;
      var li = b.closest('[data-key]'); var key = li.getAttribute('data-key');
      var q = parseInt(li.querySelector('.qty span').textContent, 10) || 0;
      var next = b.getAttribute('data-q') === 'remove' ? 0 : Math.max(0, q + parseInt(b.getAttribute('data-q'), 10));
      li.classList.add(next === 0 ? 'is-removing' : 'is-busy');
      post('/cart/change.js', { id: key, quantity: next }).then(syncCode).then(function (cart) {
        setTimeout(function () { render(cart); }, next === 0 ? 260 : 0);
      }).catch(refresh);
    });
    if (upsell) upsell.addEventListener('click', function (e) {
      var b = e.target.closest('[data-upsell-add]'); if (!b) return;
      b.classList.add('is-busy'); b.disabled = true;
      post('/cart/add.js', { items: [{ id: +b.getAttribute('data-upsell-add'), quantity: 1 }] }).then(refresh)
        .catch(function () {}).then(function () { b.classList.remove('is-busy'); b.disabled = false; });
    });
    document.querySelectorAll('.cart-link').forEach(function (a) {
      a.addEventListener('click', function (e) { if (e.metaKey || e.ctrlKey) return; e.preventDefault(); open(true); });
    });
    window.HSDrawer = { open: open, close: close, refresh: refresh };
  })();

})();
